

export const setWindowFunc = () => {

    window.setPushToken = (pushToken) => {
        window.pushToken = pushToken;
        const res = { pushToken };
        document.dispatchEvent(new CustomEvent('getPushToken', { detail: res }));
    }

    window.nativeGoogleLoginRes = (email, name, googleId) => {
        const res = { email, name, googleId };
        document.dispatchEvent(new CustomEvent('google-login', { detail: res }));
    }

    // window.onSuccessFacebookLoginFromIos = (email, name, id) => {
    //     const res = { email, name, id };
    //     document.dispatchEvent(new CustomEvent('facebook-login', { detail: res }));
    // }



    // window.onSuccessGoogleLoginFromIos = (email, name, googleId) => {
    //     const res = { profileObj: { email, name, googleId } };
    //     document.dispatchEvent(new CustomEvent('google-login-ios', { detail: res }));
    // }

    // window.imageUpload = (base64image) => {
    //     const res = { base64image };
    //     document.dispatchEvent(new CustomEvent('upload-image', { detail: res }));
    // }

}

export const sendMessageToWebview = (action, payload = {}) => {
    window.flutter_inappwebview.callHandler('handler', { action, payload });
}